import { AxiosError } from "axios";
import { b2bAxiosConfig, b2cAxiosConfig } from "@/config/axios";
import { toast } from "@sendsprint/ui-react/components/toast";
import { Api } from "@sendsprint/api-types";
import { API_APPLICATION_ID, SECRET_KEY } from "@/constants/envs";
import { setB2BAxios, setB2CAxios } from "@sendsprint/apis/services";

export const configureInterceptor = () => {
  setB2CAxios(b2cAxiosConfig);
  setB2BAxios(b2bAxiosConfig);

  const b2cResponseInterceptor = b2cAxiosConfig.interceptors.response.use(
    (response) => {
      return response;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error: AxiosError<any>) => {
      const errorResponse = error.response?.data as
        | Api.Endpoint.Response.ErrorResponse
        | undefined;
      const serverErrorResponse = error.response?.data as
        | Api.Endpoint.Response.InternalServerErrorResponse
        | undefined;

      const errorMessage: string =
        errorResponse?.ResponseMessage ||
        serverErrorResponse?.Message ||
        error.message;

      if (errorMessage && error?.config?.showToastOnError) {
        toast.error({ title: "Error", description: errorMessage });
      }

      return Promise.reject(error.response?.data || error);
    },
  );

  const b2cRequestInterceptor = b2cAxiosConfig.interceptors.request.use(
    (request) => {
      const method = request?.method?.toUpperCase();

      if (method === "POST") {
        request.data = {
          Hash: "",
          ApplicationID: API_APPLICATION_ID,
          SecretKey: SECRET_KEY,
          Email: "",
          ...(request?.data || {}),
        };
      }

      return request;
    },
  );

  const b2bResponseInterceptor = b2bAxiosConfig.interceptors.response.use(
    (response) => {
      return response;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (error: AxiosError<any>) => {
      const errorResponse = error.response?.data as any;
      const errorStatus = error.status;

      const errorMessage: string =
        errorResponse?.responseMessage?.title ||
        errorResponse?.responseMessage?.actionMessage ||
        error?.message;

      if (error?.config?.showToastOnError) {
        toast.error({ description: errorMessage, title: "Error" });
      }

      return Promise.reject(error.response?.data || error);
    },
  );

  const b2bRequestInterceptor = b2bAxiosConfig.interceptors.request.use(
    (request) => {
      request.headers.ApplicationID = API_APPLICATION_ID;
      request.headers.SecretKey = SECRET_KEY;
      request.headers.DeviceType = "1";

      return request;
    },
  );

  return () => {
    b2cAxiosConfig.interceptors.response.eject(b2cResponseInterceptor);
    b2cAxiosConfig.interceptors.request.eject(b2cRequestInterceptor);
    b2bAxiosConfig.interceptors.response.eject(b2bResponseInterceptor);
    b2bAxiosConfig.interceptors.request.eject(b2bRequestInterceptor);
  };
};
